import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-card-subtitle',
  template: '<ng-content />',
  styleUrls: ['card-subtitle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardSubtitleComponent {
}
